/** @jsxImportSource ../../i18n */
import React from 'react';
import { cx } from '../../theme/cx';
import { Card } from './Card';
import { Skeleton } from './Feedback';

export const Stat = ({ label, value, delta, icon: Icon, hint, loading = false, size = 'md', tone = 'default', className, valueClassName }) => (
  <Card tone={tone} padding={size === 'compact' ? 'sm' : 'md'} className={cx('flex flex-col', className)}>
    <div className="flex items-center justify-between gap-3">
      <p className="eyebrow truncate">{label}</p>
      {Icon && <Icon size={16} className="flex-shrink-0 text-fg-faint" aria-hidden="true" />}
    </div>
    {loading ? (
      <>
        <Skeleton className={cx('mt-4', size === 'hero' ? 'h-11 w-56' : 'h-7 w-28')} />
        <Skeleton className="mt-3 h-3 w-16" />
      </>
    ) : (
      <>
        <div className={cx(
          'num mt-3 text-fg',
          size === 'hero' ? 'font-display text-display-lg sm:text-display-xl' : size === 'compact' ? 'text-lg font-semibold tracking-[-0.01em] sm:text-xl' : 'text-2xl font-semibold tracking-[-0.01em]',
          valueClassName,
        )}
        >
          {value}
        </div>
        {(delta || hint) && (
          <div className="mt-2 flex flex-wrap items-center gap-2">
            {delta}
            {hint && <span className="text-xs text-fg-subtle">{hint}</span>}
          </div>
        )}
      </>
    )}
  </Card>
);
